__turbopack_context__.v({
  "node": "b8KxYW_node",
  "pulse": "b8KxYW_pulse",
});
